import React from 'react';
import HookPage from '../components/HookPage';

function HookPageTemplate(props) {
  return /*#__PURE__*/React.createElement(HookPage, props);
}

export default HookPageTemplate;
export var pageQuery = "235025319";